import React, { useState, useEffect, useRef, setLoading, setError } from 'react';
import axios from 'axios';
import api from './api';

const API_BASE_URL = 'http://localhost:8000'; // Or your deployed backend URL

// const tickerAPI = async (ticker) => {

//   getGeneralDetails: (ticker) => api.get(`/api/metrics/ticker=${ticker}`)

//   getMetrics: (requestInput) => api.get(`/api/metrics/technical-analysis/`, requestInput),

//   getPredictions: (requestInput) => api.get(`/api/metrics/predict`, requestInput),
// };

export const metricsApi = {

    getGeneralDetails : async (ticker) => {
        try {
            const generalResponse = await axios.get(`${API_BASE_URL}/api/portfolio/metrics?ticker=${ticker}`)
            console.log('✅ General details response:', generalResponse.data);    

            // if (!response.ok) {
            //     throw new Error(`HTTP error! status: ${response.status}`);
            // }
            if (generalResponse.status !== 200) {  // This might be the issue
                throw new Error(`HTTP error! status: ${generalResponse.status}`);
            }            
            return generalResponse.data;
        } catch (error) {
            console.error("Error fetching stock metrics:", error);
            throw error;
        }
    },

    getMetrics : async (ticker, period) => {
        const metricsRequestData = {
            symbol: ticker,
            period: period
        };
        try {
            const metricsResponse = await axios.post(`${API_BASE_URL}/api/metrics/technical-analysis`,
                metricsRequestData,
                {
                    headers: {
                    'Content-Type': 'application/json',
                    'accept': 'application/json',
                    },
                }
            );        
            console.log('✅ General details response:', metricsResponse.data);
            // if (!response.ok) {
            //     throw new Error(`HTTP error! status: ${response.status}`);
            // }
            if (metricsResponse.status !== 200) {  // This might be the issue
                throw new Error(`HTTP error! status: ${metricsResponse.status}`);
            }            

            return await metricsResponse.data;
        } catch (error) {
            console.error("Error fetching stock metrics:", error);
            throw error;
        }
    },

    getPredictions : async (ticker, period, days, news, risk) => {
        const predictRequestData = {
            symbol: ticker,  
            period: period,
            prediction_days: days,
            include_news: true,
            risk_tolerance: "medium"
        };

        console.log('Symbol:', ticker);
        console.log('Request Data:', predictRequestData);
        console.log('Full URL:', `${axios.defaults.baseURL}`);

        try {
            const predictResponse = await axios.post(`${API_BASE_URL}/api/metrics/predict`,
                predictRequestData,
                {
                    headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    },
                }
            );
            console.log('✅ General details response:', predictResponse.data);
            // if (!response.ok) {
            //     throw new Error(`HTTP error! status: ${response.status}`);
            // }
            if (predictResponse.status !== 200) {  // This might be the issue
                throw new Error(`HTTP error! status: ${predictResponse.status}`);
            }                

            return predictResponse.data;
        } catch (err) {
            console.error('Full error:', err.response); // Log detailed error
            console.error('Request config:', err.config);
            console.error('Error message:', err.message);
            throw err;            
            // setError(err.response?.data?.detail || err.message);
        }
    }
};

export default metricsApi;